export function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  COLLPSE_CHANGE: 'COLLPSE_CHANGE',
  COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  SET_CURRENT_APP: 'SET_CURRENT_APP',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',

  toggleCollapsed: () => ({
    type: actions.COLLPSE_CHANGE
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height
    };
  },
  toggleOpenDrawer: () => ({
    type: actions.COLLPSE_OPEN_DRAWER
  }),
  changeOpenKeys: openKeys => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys
  }),
  changeCurrent: current => ({
    type: actions.CHANGE_CURRENT,
    current
  }),

  searchTermUpdated(searchTerm){
    return {
      type: actions.SET_SEARCH_TERM,
      searchTerm,
    }
  },
  
  appSelected: ( app, secondApp) => {
    console.log( ' app action', app);
    return({
    type: actions.SET_CURRENT_APP,
    app,
    secondApp
  })
},

  // searchTermUpdated: searchTerm => ({
  //   type: actions.SET_SEARCH_TERM,
  //   searchTerm,
  // })

};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/app/actions.js